import "./App.css";
import { Layout, HealthModal } from "processhub-components-lib";
import Header from "components/layout/Header/Header";
import DashboardConfiguration from "components/shared/DashboardConfiguration/DashboardConfiguration";
import Alarms from "pages/alarms/Alarms";
import TicketsContainer from "pages/tickets/TicketsContainer";
import { Navigate, Route, Routes } from "react-router-dom";
import UsersContainer from "pages/users/UsersContainer";
import TagContainer from "pages/tags/TagContainer";
import {
  MinifiedMenu,
  DiscreteSlider,
  Modal
} from "processhub-components-lib";
import TabsDashboard from "pages/Dashboard/AllDynamicTabs/TabsDashboard";
import modalConfig from "config/modal/modalConfig";
import allHooks from "hooks";
import { useState, useContext, useEffect, Suspense } from "react";
import { ModalContext } from "hooks/ModalProvider";
import AllAssets from "pages/all-assets/AllAssets";
import ExpressionContainer from "pages/expressions/ExpressionContainer";
import Documents from "pages/documents/Documents";
import { PageNotFound } from "processhub-components-lib";
import loginBackground from "assets/loginBackground.jpg";
import DataSources from "pages/dataSources/DataSources";
import { Link } from "react-router-dom";
import HealthContainer from "pages/HealthCheck";
import Logs from "pages/Logs";
import { getExtractedPath } from "utilities/extractedPath";
import extractUUIDs from "components/layout/utils/extractUUIDs";
import { useAiChat } from "hooks/AiChatContext";
import AiChat from "components/AiChat/AiChat";
import { useMinifiedMenu } from "hooks/useMinifiedMenu";
import { useUnityActions } from "hooks/unityActions";
import UnityRouteHandler from "pages/unity/UnityRouteHandler";
import useUnity from "hooks/UseUnity";
import discreteSliderConfig from "config/unity/discreteSliderConfig";
import healthCheckApiConfig from "config/modal/healthCheckApiConfig";
import Projects from "pages/Projects/projects";
import OrganizationAndUsersContainer from "pages/organization-and-users/OrganizationAndUsers";

function App() {
  const [refreshMode, setRefreshMode] = useState('');
  const isLoading = false;
  const [selectedTag, setSelectedTag] = useState<any>({
    action: "",
    value: null,
  });
  const [isMovementDisabled, setIsMovementDisabled] = useState(0);
  const { screenMode, renderQuality } = useUnityActions();
  const { modalType, setModalType, showProjects, initialSettingsTab, setInitialSettingsTab, showHealth, setShowHealth } = useContext(ModalContext);
  const {
    setMinifiedMenuOpen,
  } = useMinifiedMenu();
  const { TimelineShown } = useUnity();

  useEffect(() => {
    if (modalType === '' || modalType === 'report') {
      setMinifiedMenuOpen(true);
    }
    if (modalType !== '' && modalType !== 'report') {
      setMinifiedMenuOpen(false);
    }
    setSelectedTag({
      action: modalType,
      value: null,
    });
    if (modalType === 'health') {
      setShowHealth(true);
    }
  }, [modalType]);

  useEffect(() => {
    if (!showHealth) {
      setModalType('');
    }
  }, [showHealth]);

  const refresh = async () => { };
  const baseUrl = getExtractedPath();
  const { currOrg, curSol } = extractUUIDs(baseUrl);

  const { aiChatShown } = useAiChat();
  const [menuVisibilityParams, setMenuVisibilityParams] = useState({ left: true, right: true });

  function sendCanvasVisibility(state: number) {
    if (window.vuplex) {
      window.vuplex.postMessage(JSON.stringify({ object: "CanvasVisibility", type: "CanvasVisibility", method: "SetStatus", arguments: [state] }));
    }
  }

  useEffect(() => {
    if (window.vuplex) {
      if (location.pathname.endsWith('/3d-dashboard')) {
        sendCanvasVisibility(1);
      }
      else {
        sendCanvasVisibility(0);
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    if (window.vuplex) {
      if (showProjects) {
        sendCanvasVisibility(0);
      } else {
        if (location.pathname.endsWith('/3d-dashboard')) {
          sendCanvasVisibility(1);
        } else {
          sendCanvasVisibility(0);
        }
      }
    }
  }, [showProjects, location]);

  useEffect(() => {
    if (selectedTag.action !== '') {
      setIsMovementDisabled(1);
    }
    else {
      setIsMovementDisabled(0);
    }
  }, [selectedTag]);

  useEffect(() => {
    if (window.vuplex) {
      const message = JSON.stringify({ object: "__S:ReactInputBlocker__", type: "ReactInputBlocker", method: "SetBlockState", arguments: [isMovementDisabled] });
      window.vuplex.postMessage(message);
    }
  }, [isMovementDisabled]);

  useEffect(() => {
    if (window.vuplex) {
      const initWindowMode = localStorage.getItem('windowMode');
      const initRenderQuality = localStorage.getItem('renderQuality');

      const message = JSON.stringify({ object: "__ApplicationManager__", type: "ApplicationManager", method: "SetScreenMode", arguments: [initWindowMode ? Number(initWindowMode) : 0] });
      window.vuplex.postMessage(message);

      window.vuplex.postMessage(JSON.stringify({
        object: 'ReactUIManager',
        type: 'ReactUIManager',
        method: 'SetToggleGroup',
        arguments: [JSON.stringify(['3DQualityRender', initRenderQuality ? initRenderQuality : 0])]
      }));
    }
  }, [screenMode, renderQuality]);

  useEffect(() => {
    if (window.vuplex) {
      const projects = JSON.stringify({
        object: "__ProjectsManager__",
        type: "ProjectsManager",
        method: "SetProject",
        arguments: [JSON.stringify({ oid: currOrg, sid: curSol })]
      });

      const getInitialWindowMode = () => {
        const initWindow = localStorage.getItem('windowMode');
        if (initWindow) {
          return Number(initWindow);
        }
        else {
          localStorage.setItem('windowMode', '0');
          return 0;
        }
      };

      const initialWindowMode = JSON.stringify({ object: "__ApplicationManager__", type: "ApplicationManager", method: "SetScreenMode", arguments: [getInitialWindowMode()] });

      window.vuplex.postMessage(projects);
      window.vuplex.postMessage(initialWindowMode);
    }
  }, []);

  const genModalItems = (mode: 'note' | 'bubble' | 'preview' | 'chart' | 'widget' | 'label' | 'doc' | 'pins' | 'measurements' | 'aiChat', data: any, position: 'left' | 'right') => {
    if (mode === 'aiChat') {
      return (
        <div className="h-full w-full bg-gray/70">
          <AiChat setIsMovementDisabled={setIsMovementDisabled} />
        </div>
      );
    }

    return null;
  };

  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route element={<Layout><Header /></Layout>}>
            <Route index path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/new-dashboard" element={<TabsDashboard />} />
            <Route path="/3d-dashboard" element={<UnityRouteHandler />} />
            <Route path="/dashboard" element={<TabsDashboard />} />
            <Route path="/dashboard-configuration">
              <Route element={<DashboardConfiguration />}>
                <Route
                  index
                  element={<Navigate to="/dashboard-configuration/tags" />}
                />
                <Route path="tags" element={<TagContainer />} />
                <Route path="expressions" element={<ExpressionContainer />} />
                <Route path="documents" element={<Documents />} />
                <Route path="all-assets" element={<AllAssets />} />
              </Route>
            </Route>
            <Route path="/alarms" element={<Alarms />} />

            <Route path="/projects" element={<Projects />} />
            <Route path="/users-and-projects" element={<OrganizationAndUsersContainer type="users" />} />
            <Route path="/tickets" element={<TicketsContainer />} />
            <Route path="/users" element={<UsersContainer />} />
            <Route path="/data-sources" element={<DataSources />} />
            <Route path="/logs" element={<Logs />} />
            <Route path="/health" element={<HealthContainer />} />
            <Route path="/3d-dashboard" element={<UnityRouteHandler />} />
            <Route path="*" element={
              <PageNotFound type={0} loginBG={loginBackground}>
                <Link to={"https://processhub.ai/"} style={{ color: 'darkblue', textDecoration: 'underline' }}>www.processhub.ai</Link>
              </PageNotFound>
            }
            />
          </Route>
        </Routes>
      </Suspense >

      <Modal hasPointClouds={true} page="tags" setModalType={setModalType} isLoading={isLoading} refresh={refresh} selectedTag={selectedTag} setSelectedTag={setSelectedTag} modalConfig={modalConfig} hooks={allHooks} initialSettingsTab={initialSettingsTab ?? undefined} setInitialSettingsTab={setInitialSettingsTab} />
      {
        aiChatShown && !location.pathname.endsWith('/3d-dashboard') &&
        <div className="h-screen w-screen absolute top-0 left-0 z-50 overflow-hidden pointer-events-none">
          <div className="relative h-full w-full">
            <div className="pointer-events-auto">
              <MinifiedMenu genModalItems={genModalItems} allHooks={allHooks} visibilityParams={menuVisibilityParams} setVisibilityParams={setMenuVisibilityParams} />
            </div>
          </div>
        </div>
      }
      {
        TimelineShown && !location.pathname.endsWith('/3d-dashboard') &&
        <div className="absolute w-full h-max left-0 top-20 flex items-center justify-center">
          <div className="z-30">
            <DiscreteSlider hooks={allHooks} discreteSliderConfig={discreteSliderConfig} />
          </div>
        </div>
      }
      {
        showHealth &&
        <div className="absolute left-0 top-0 w-screen h-screen bg-dark/35 flex items-center justify-center align-middle" onClick={() => setShowHealth(false)}>
          <div className="w-[85%] h-[85%] mt-10 z-50 flex items-center justify-center">
            <HealthModal setShowHealth={setShowHealth} healthCheckApiConfig={healthCheckApiConfig} />
          </div>
        </div>
      }
    </>
  );
}

export default App;
